export const meta = {
  title: 'வரிசைப் பலகை: வெள்ளைப் பலகை இல்லாமல் வரிசையை நடத்துங்கள்',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'pos', 'staff'],
};

வரிசைப் பலகைதான் உங்கள் டாஷ்போர்டின் இதயம். அதைத் திறந்து வைத்திருக்கும் ஒவ்வொரு சாதனத்திலும் — காசாளர் கவுண்டர், கழுவுபவரின் டேப்லெட், உங்கள் தொலைபேசி — நேரலையில் புதுப்பிக்கப்படுகிறது.

## மூன்று பத்திகள்

செயலில் உள்ள ஒவ்வொரு டிக்கெட்டும் மூன்று பத்திகளில் ஒன்றில் இருக்கும்:

- **வரிசையில்** — முன்பதிவு செய்யப்பட்டு, கழுவும் இடத்திற்காகக் காத்திருக்கிறது. வரிசையில் அதன் இடம் காட்டப்படும்.
- **கழுவப்படுகிறது** — இப்போது கழுவப்பட்டுக்கொண்டிருக்கிறது.
- **எடுத்துச்செல்லத் தயார்** — கழுவி முடிந்து, வாடிக்கையாளர் பணம் செலுத்தி எடுத்துச்செல்லக் காத்திருக்கிறது.

ஒவ்வொரு அட்டையிலும் டிக்கெட் எண், தொகுப்பு, எண் தகடு, மொத்தத் தொகை காட்டப்படும். வரிசைப் பத்தி காலியாக இருந்தால் நிர்வகிக்க எதுவுமில்லை — வாடிக்கையாளர் உங்கள் QR-ஐ ஸ்கேன் செய்த கணமே புதிய முன்பதிவுகள் தோன்றும்.

## அடுத்ததைத் தொடங்கு

**அடுத்ததைத் தொடங்கு** பொத்தான் «வரிசையில்» பத்தியின் மேலே இருக்கும்; எப்போதும் வரிசையின் முதல் டிக்கெட்டின் எண்ணைக் காட்டும். ஒரு தட்டில் அந்த டிக்கெட் கழுவலுக்குள் செல்லும். உங்கள் கழுவுபவர்கள் ஒரே ஒரு பொத்தானை மட்டும் பயன்படுத்த விரும்பினால், அது இதுதான்.

குறிப்பிட்ட ஒரு காரை முன்னே அனுப்ப, எந்த அட்டையிலும் உள்ள **தொடங்கு** பொத்தானையும் தட்டலாம் — செயல்பாடு ஒன்றுதான்; வரிசையின் முதலில் இருக்க வேண்டியதில்லை.

## வரிசையை மாற்றியமைத்தல்

«வரிசையில்» பத்தியின் ஒவ்வொரு அட்டையின் இடது ஓரத்திலும் **மேல்/கீழ் அம்புகள்** உள்ளன. ஒவ்வொரு தட்டும் டிக்கெட்டை ஒரு இடம் நகர்த்தும். வாடிக்கையாளரின் செயலியில் அவரது இடம் உடனடியாகப் புதுப்பிக்கப்படும்.

இழுத்து-விடுதல் (drag-and-drop) இல்லை — ஈரக் கை டேப்லெட்டில், திட்டமிட்ட ஒற்றைத் தட்டுகள் தவறுதலான இழுப்புகளை விடச் சிறந்தவை.

## நிறுத்தி வைத்தல், மீண்டும் தொடர்தல்

வாடிக்கையாளர் முன்பதிவு செய்துவிட்டு மதிய உணவுக்குச் சென்றுவிட்டாரா? அவரது அட்டையில் **நிறுத்திவை** என்பதைத் தட்டுங்கள். டிக்கெட் வரிசையிலிருந்து விலகி, «வரிசையில்» பத்தியின் கீழுள்ள **நிறுத்தி வைக்கப்பட்டவை** பகுதியில் நிற்கும்; பின்னால் இருந்த கார்கள் முன்னேறும்.

வாடிக்கையாளர் திரும்பியதும் **தொடர்** என்பதைத் தட்டுங்கள். டிக்கெட் **வரிசையின் கடைசியில்** மீண்டும் சேரும் — பழைய இடத்தில் அல்ல. முன்னுரிமை தர விரும்பினால், மேல் அம்பால் முன்னே நகர்த்துங்கள். இது வேண்டுமென்றே செய்யப்பட்டது: காத்திருந்தவர்கள் தங்கள் இடத்தை அமைதியாக இழக்கக்கூடாது.

## தயார், எடுத்துச்செல்லப்பட்டது, ரத்து

- **தயார்** — கழுவப்படும் டிக்கெட்டை «எடுத்துச்செல்லத் தயார்» நிலைக்கு நகர்த்தி, கார் தயார் என வாடிக்கையாளருக்கு அறிவிக்கும்.
- **எடுத்துச்செல்லப்பட்டது** — கடைசித் தட்டு. டிக்கெட் வரலாற்றில் சேமிக்கப்படும்; அறிக்கைகளும் விசுவாசத் திட்டமும் அங்கிருந்து எடுத்துக்கொள்ளும். பணம் POS திரையில் உறுதிப்படுத்தப்படுகிறது.
- **ரத்து** — வரிசையில், கழுவலில் அல்லது நிறுத்தி வைக்கப்பட்ட நிலையில் கிடைக்கும். எடுத்துச்செல்லத் தயாரான டிக்கெட்டைப் பலகையில் ரத்து செய்ய முடியாது — POS-இல் முடித்துவிடுங்கள்.

## ஒன்றுக்கு மேற்பட்ட கடைகளா?

பலகையின் மேலுள்ள **கடை மாற்றி** முழுக் காட்சியையும் உங்கள் கடைகளுக்கிடையே மாற்றும். ஒவ்வொரு கடைக்கும் தனி வரிசை, தனி QR குறியீடு, தனி டிக்கெட் எண்கள்.

## வாடிக்கையாளர் என்ன பார்க்கிறார்

பலகையில் நீங்கள் செய்யும் ஒவ்வொரு நகர்வும் வாடிக்கையாளரின் செயலியில் பிரதிபலிக்கும். வரிசையில் தங்கள் இடத்தைப் பார்ப்பார்கள்; ஒவ்வொரு படியிலும் — வரிசையில் சேரும்போது, கழுவல் தொடங்கும்போது, கார் தயாரானதும், நீங்கள் நிறுத்தி வைத்தாலோ ரத்து செய்தாலோ — அறிவிப்பு பெறுவார்கள். இனி இடம் முழுக்க எண் தகட்டைக் கத்த வேண்டியதில்லை.
